/**
* Created by vouill on 3/16/18.
*/

<template>
  <div class="action-item">
    <img
      class="cover-picto"
      :src="imgUrl">
    <div class="v-title">. {{ action.fields.title }} .</div>
    <div class="v-desc">{{ action.fields.description }}</div>
  </div>
</template>

<style scoped lang="scss">
.action-item {
  margin: 0 2em;
  margin-bottom: 3em;
  width: 250px;
}
.v-title {
  font-size: 18px;
  font-weight: bold;
  font-family: "Roboto Slab", serif;
  margin-bottom: 1em;
}
.v-desc {
  color: #464646;
  font-size: 15px;
}
.cover-picto {
  height: 100px;
  background-size: cover;
  margin-bottom: 1em;
}
</style>
<script>
import { getAsset } from "../../../utils/contentful";

export default {
  name: "ActionItem",
  props: { action: Object, includes: Object },
  computed: {
    imgUrl: function() {
      const { action, includes } = this;
      return getAsset(includes, action.fields.coverImg.sys.id).fields.file.url;
    }
  }
};
</script>
